// Certificazioni aziendali — PUBBLICATE con riquadro testuale provvisorio.
// Nessun logo ISO/IQNET recuperato da Internet. Prima della pubblicazione
// definitiva il riquadro testuale potrà essere sostituito dal marchio
// autorizzato presente nel certificato originale, previa verifica di validità.
export const CERT_PUBLISHED = true;

// Standard di riferimento (riquadro testuale istituzionale, due righe).
export const CERT_STANDARD = "UNI EN ISO 9001:2015";
export const CERT_BOX_TITLE = "SISTEMA DI GESTIONE PER LA QUALITÀ";

// Etichetta comune (Chi Siamo + Home)
export const CERT_EYEBROW = "Qualità certificata";

// --- A) Sezione completa (pagina Chi Siamo) -------------------------------
export const CERT_SECTION = {
  title: "Un impegno organizzato e verificabile.",
  paragraphs: [
    "MEDISISTEM adotta un sistema di gestione per la qualità conforme alla norma UNI EN ISO 9001:2015. Un modello organizzativo riconosciuto a livello internazionale, fondato sul controllo dei processi, sull'attenzione alle esigenze del cliente e sul miglioramento continuo.",
    "La certificazione rappresenta il nostro impegno nel gestire ogni attività secondo procedure definite, responsabilità chiare e controlli costanti. Dalla selezione delle soluzioni alla consulenza, dalla gestione delle richieste al supporto offerto al cliente, lavoriamo per garantire affidabilità, continuità e qualità del servizio.",
  ],
  points: [
    {
      title: "Processi controllati",
      desc: "Attività organizzate attraverso procedure definite, verifiche periodiche e responsabilità chiaramente individuate.",
    },
    {
      title: "Attenzione al cliente",
      desc: "Ascolto delle esigenze, gestione puntuale delle richieste e ricerca costante di soluzioni adeguate.",
    },
    {
      title: "Miglioramento continuo",
      desc: "Valutazione dei risultati e aggiornamento dei processi per rendere il servizio sempre più efficace e affidabile.",
    },
  ],
  note: "La certificazione UNI EN ISO 9001:2015 riguarda il sistema di gestione per la qualità di MEDISISTEM. Non costituisce una certificazione automatica dei singoli prodotti commercializzati o distribuiti.",
};

// --- B) Richiamo in Home ---------------------------------------------------
export const CERT_HOME = {
  title: "La qualità non è soltanto un principio. È un metodo.",
  text: "Il sistema di gestione per la qualità di MEDISISTEM è conforme alla norma UNI EN ISO 9001:2015: processi controllati, attenzione al cliente e miglioramento continuo.",
  cta: "Scopri il nostro impegno per la qualità",
};

// Ancora comune (Chi Siamo → sezione certificazioni)
export const CERT_LINK = "/chi-siamo#certificazioni";
